import { Advisory } from 'gocclr-shared-ui/dist/elements/advisory';
import { Advisory as AdvisoryModel } from '../../model/advisory'

export interface AdvisoriesProps {
    advisories: AdvisoryModel[];
    onClose?: (index: number) => void;
    containerRef?: React.RefObject<HTMLDivElement>;
}

export function Advisories(props: AdvisoriesProps) {
    const onClose = (index: number) => {
        return () => {
            props.onClose?.(index);
        };
    }
    return (
        <div className='advisories-container' ref={props.containerRef}>
            {props.advisories.map((advisory, index) => {
                const key = `${advisory.code ? advisory.code.toFixed(0) : 'no-code'}-${index}`;
                return (
                    <Advisory
                        key={key}
                        advisoryType={advisory.type}
                        advisoryCode={advisory.code}
                        advisory={advisory.description}
                        isDismissable={true}
                        onClose={onClose(index)}
                    />
                );
            })}
        </div>
    );
}